import { render, staticRenderFns } from "./MarketingSummaryReport.vue?vue&type=template&id=958b1820&scoped=true&"
import script from "./MarketingSummaryReport.vue?vue&type=script&lang=js&"
export * from "./MarketingSummaryReport.vue?vue&type=script&lang=js&"
import style0 from "./MarketingSummaryReport.vue?vue&type=style&index=0&id=958b1820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958b1820",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VContainer,VProgressLinear,VRow,VSwitch})
